// Hours a part-time helper can be booked for, per visit. This is the only
// list: the booking cards, the hub's rate table, the packages and the FAQ all
// read it. Changing it also needs the backend to accept and price the new
// durations, because the charged amount comes from the API
// (request.serviceCosts.finalCost), not from this file.
export const HELPER_SERVICE_HOURS = [2, 2.5, 3, 3.5, 4]

// Undiscounted hourly rate (SGD) that the per-visit discount is taken from.
// Mirrors `base` in the backend's DomesticCostCalculator; change both together.
// 26.4 -> 29.4 for the Nov 2026 relaunch (weekly 3 h $69.52, one-off $77.90).
export const HELPER_BASE_RATE = 29.4

export function helperCostCalculation(currencyCd, helperService, babySitterService, elderlyCareService, cookingAssistanceService) {
    const discountPercent = 8;//general discount
    const base = HELPER_BASE_RATE
    const discountFactor = 1

    for (const hours of HELPER_SERVICE_HOURS) {
        let helperCost = (base * hours) - ((discountFactor*10 + hours) * ((base + hours) * hours)/100);
        helperCost = helperCost - helperCost*discountPercent/100

        let babySitterCost = helperCost

        let elderlyCareCost = helperCost + (5 * hours)

        let cookingAssistanceCost = helperCost + (5 * hours)

        // `hours` used to be the for...in index ("0 hrs" to "4 hrs"). The
        // booking card never read it, so nobody noticed.
        let helperObj = { hours: hours + " hrs", unit: hours, currencyCd: currencyCd, rate: helperCost.toFixed(2) }
        let babySitterObj = { hours: hours + " hrs", unit: hours, currencyCd: currencyCd, rate: babySitterCost.toFixed(2) }
        let elderlyCareObj = { hours: hours + " hrs", unit: hours, currencyCd: currencyCd, rate: elderlyCareCost.toFixed(2) }
        let cookingAssistanceObj = { hours: hours + " hrs", unit: hours, currencyCd: currencyCd, rate: cookingAssistanceCost.toFixed(2) }

        helperService.push(helperObj)
        babySitterService.push(babySitterObj)
        elderlyCareService.push(elderlyCareObj)
        cookingAssistanceService.push(cookingAssistanceObj)
    }
}

// The rows above are the weekly/fortnightly price. A one-off visit is priced
// with a smaller length discount. This mirrors DomesticCostCalculator in the
// backend (the "Only once" branch of calculateHelperServiceCost). The 8% is the
// Domestic Services discountPercent in REQUEST_CATEGORY_SETTINGS, applied by
// ServiceCostService. Saturday and short-notice surcharges are added on top at
// booking, so neither price here includes them.
export function helperOneOffRows() {
    const discountPercent = 8
    const base = HELPER_BASE_RATE
    return HELPER_SERVICE_HOURS.map((hours) => {
        let cost = (base * hours) - ((1 + hours) * (base * hours) / 100)
        cost = cost - cost * discountPercent / 100
        return { hours: hours + " hrs", unit: hours, rate: cost.toFixed(2) }
    })
}

// Headline numbers for page copy: titles, meta descriptions, FAQ answers.
// They are derived from the rows the page renders, so the copy and the booking
// card cannot disagree. The old hub title said "$19/hr" while the card charged
// about $20.
//   fromPerHour: lowest hourly rate (the longest visit), e.g. "22.75"
//   fromTotal:   price of the shortest visit, e.g. "47.16"
export function helperRateSummary(rows) {
    const perHour = rows.map((row) => Number(row.rate) / row.unit)
    return {
        minHours: HELPER_SERVICE_HOURS[0],
        maxHours: HELPER_SERVICE_HOURS[HELPER_SERVICE_HOURS.length - 1],
        fromPerHour: Math.min(...perHour).toFixed(2),
        fromTotal: Number(rows[0].rate).toFixed(2),
    }
}
